import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import {
  Button,
  Col,
  ConfigProvider,
  Form,
  message,
  notification,
  Spin,
} from "antd";
import { EconnectStepOne } from "./components/hse/step-one";
import { EconnectStepTwo } from "./components/hse/step-two";
import EconnectStepThreeBeverage from "./components/hse/step-three-beverage";
import EconnectStepThreePublic from "./components/hse/step-three-public";
import { useId24 } from "../../drivers/id24/Id24Provider";
import { AgendesService } from "./services/agendes-service";
import { MasterDataEventService } from "../../api/master-data-event.service";
import { UserEventService } from "../../api/user.service";
import { IresponseAgendes } from "./common/index";
import { CustomerUrlService } from "../../api/customer-url.service";
import { CustomerUrlDto } from "../../types/customer-url.type";

import { loadAppConfig } from "../../configs/app-config";

type NotificationType = "success" | "info" | "warning" | "error";

export const MainHseForm: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { agendaid, typeregis, customerid } = useParams<{
    agendaid: string;
    typeregis: string;
    customerid: string;
  }>();

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [summaryForm] = Form.useForm();
  const [agenda, setAgenda] = useState<IresponseAgendes[]>();

  const [masterDataEvent, setMasterDataEvent] = useState<
    { value: string; label: string }[]
  >([]);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingNavigate, setLoadingNavigate] = useState<boolean>(false);
  const [stepsLength, setStepsLength] = useState<number>(4);
  const [customerData, setCustomerData] = useState<CustomerUrlDto>({
    id: 0,
    customerName: "",
    customerNumber: "",
    limit: 0,
    agendaId: "",
    createdAt: "",
    updatedAt: "",
  });

  useEffect(() => {
    if (loading) {
      featchData();
    }
  }, [loading]);

  const featchData = async () => {
    try {
      if (agendaid) {
        const resAgenda = await AgendesService(apiBaseUrl).getAgenda(agendaid);
        const resMasterDataEvent = await MasterDataEventService(
          apiBaseUrl,
        ).getByEventId(agendaid);
        setMasterDataEvent(resMasterDataEvent.dataSource);
        setAgenda(resAgenda);
        if (customerid) {
          const resCountCustomer = await CustomerUrlService(
            apiBaseUrl,
          ).countCustomerId(customerid, agendaid);
          if (resCountCustomer.status === 505) {
            navigate(
              `/activity-agenda/limit/partners/${agendaid}/${customerid}`,
            );
          }
          const resCustomer: CustomerUrlDto = await CustomerUrlService(
            apiBaseUrl,
          ).getOneCustomerId(customerid, agendaid);
          form.setFieldValue("company", resCustomer.customerName);
          setCustomerData(resCustomer);
        }
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const onSubmitform = () => {
    form.validateFields().then(async (validateValue) => {
      await AgendesService(apiBaseUrl).resgister(agendaid, validateValue);
      onChangeCurrentStep(currentStep + 1);
    });
  };

  const openNotificationWithIcon = (type: NotificationType) => {
    if (type === "success")
      return notification[type]({
        message: "สำเร็จ",
        description:
          "กรุณานำ QR-Code ที่ได้รับจากอีเมลของท่านมาเพื่อเช็คอินเข้าร่วมงาน",
      });
    if (type === "error")
      return notification[type]({
        message: "ไม่สำเร็จ",
        description: "ขออภัย เนื่องจากอีเมลนี้มีการลงทะเบียนไปแล้ว",
      });
  };

  const onChangeFormStepOne = async () => {};

  const onChangeCurrentStep = (step: number) => {
    setCurrentStep(step);
  };

  const submitFormParthner = async (event: any) => {
    const data = {
      dataSource: {
        fullname: event.fullName,
        position: event.position,
        company: { value: customerid, label: form.getFieldValue("company") },
        businessEmail: event.businessEmail,
        phoneNumber: event.phoneNumber,
        businessType: masterDataEvent.filter(
          (item) => item.value === event.businessType,
        )[0],
        type: typeregis === "partners" ? "B" : typeregis === "vip" ? "V" : "A",
        otherText: event.otherText,
      },
    };
    try {
      if (agendaid) {
        setLoadingNavigate(true);
        const resCreate = await UserEventService(apiBaseUrl).createByEvent(
          agendaid,
          data,
        );
        if (resCreate.status === 500) {
          setLoadingNavigate(false);
          message.error(resCreate.message);
        } else if (resCreate.status === 505) {
          navigate(`/activity-agenda/limit/partners/${agendaid}/${customerid}`);
        } else {
          setLoadingNavigate(false);
          navigate(
            `/activity-agenda/activity-step/${agendaid}/${resCreate.dataSource.ticketNumber}`,
          );
        }
      }
    } catch (err) {}
  };

  const submitFormGeneral = async (event: any) => {
    // console.log(event);
    const dataAttendee = {
      company: { value: "0", label: event.companyName },
      industry: event.industry,
      otherIndustry: event.otherIndustry,
      purposeofAttending: event.purposeofAttending
        ? event.purposeofAttending.join(",")
        : "",
      otherPurposeofAttending: event.otherPurposeofAttending,
    };
    // event.attendeeType === "student"
    //   ? {
    //       institution: event.institution,
    //       fieldofStudy: event.fieldofStudy,
    //       otherFieldofStudy: event.otherFieldofStudy,
    //       purposeofAttendingS: event.purposeofAttendingS,
    //       otherPurposeofAttendingS: event.otherPurposeofAttendingS,
    //     }
    //   : {
    //       company: { value: "0", label: event.companyName },
    //       industry: event.industry,
    //       position: event.position,
    //       otherIndustry: event.otherIndustry,
    //       otherPurposeofAttending: event.otherPurposeofAttending,
    //       purposeofAttending: event.purposeofAttending,
    //     };
    const data = {
      dataSource: {
        fullname: event.fullName,
        businessEmail: event.businessEmail,
        phoneNumber: event.phoneNumber,
        attendeeType: event.attendeeType,
        type: typeregis === "partners" ? "B" : typeregis === "vip" ? "V" : "A",
        ...dataAttendee,
      },
    };
    try {
      if (agendaid) {
        setLoadingNavigate(true);
        const resCreate = await UserEventService(apiBaseUrl).createByEvent(
          agendaid,
          data,
        );
        if (resCreate.status === 500) {
          setLoadingNavigate(false);
          message.error(resCreate.message);
        } else {
          setLoadingNavigate(false);
          message.success("success");
          navigate(
            `/activity-agenda/activity-step/${agendaid}/${resCreate.dataSource.ticketNumber}`,
          );
        }
      }
    } catch (err) {}
  };

  const submitFormGeneralPublic = async (event: any) => {
    const publicForm = form.getFieldsValue();
    const beverageForm = {
      drink: event.drink || "",
      other: event.other || "",
    };
    const data = {
      dataSource: {
        ...publicForm,
        ...beverageForm,
      },
    };
    try {
      if (agendaid) {
        setLoadingNavigate(true);
        const resCreate = await UserEventService(apiBaseUrl).createByEvent(
          agendaid,
          data,
        );
        if (resCreate.status === 500) {
          setLoadingNavigate(false);
          message.error(resCreate.message);
        } else if (resCreate.status === 505) {
          navigate(`/activity-agenda/limit/partners/${agendaid}/${customerid}`);
        } else {
          setLoadingNavigate(false);
          navigate(
            `/activity-agenda/activity-step/${agendaid}/${resCreate.dataSource.ticketNumber}`,
          );
        }
      }
    } catch (err) {}
  };
  const steps = [
    {
      key: 0,
      title: "Agendar",
      content: (
        <EconnectStepOne
          onChangeData={onChangeFormStepOne}
          onChangeCurrentStep={onChangeCurrentStep}
          currentStep={currentStep}
        />
      ),
    },
    {
      key: 1,
      title: "Consent",
      content: (
        <EconnectStepTwo
          onChangeCurrentStep={onChangeCurrentStep}
          currentStep={currentStep}
          stepsLength={stepsLength}
        />
      ),
    },
    {
      key: 2,
      title: "Form",
      content: (
        <EconnectStepThreePublic
          onChangeCurrentStep={onChangeCurrentStep}
          currentStep={currentStep}
          stepsLength={stepsLength}
          form={form}
          submitFormGeneral={submitFormGeneralPublic}
        />
      ),
    },
  ];

  return (
    <>
      <Spin tip="Loading..." spinning={loading}>
        <Spin tip="Loading..." spinning={loadingNavigate}>
          <div className="w-[webkit-fill-available] rounded-[20px]  ">
            {steps.map(({ title, content }, i) => {
              return (
                <Col
                  hidden={i === currentStep ? false : true}
                  md={24}
                  key={title}
                >
                  {content}
                </Col>
              );
            })}
            <br></br>
            <Form.Item className="flex justify-center items-center w-full">
              <div className="flex w-full gap-[5px]"></div>
            </Form.Item>
          </div>
        </Spin>
      </Spin>
    </>
  );
};
